// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__QmMEw","box":"style_box__oLqbq","active":"style_active__c339Z","title":"style_title__HU5h9","item":"style_item__lrD3V"};